<template>
    <v-dialog v-model="formdialog" >
        <v-card>
            <v-container fluid>
                <h1>{{ company }} {{ neworedit }} Purchase</h1>
                <v-form @submit.prevent="">
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-autocomplete
                                label="Vendor Name"
                                v-model="bill.ps_vname"
                                :items="vendors"
                                item-title="vname"
                                item-value="vname"
                                density="default"
                                placeholder="Vendor name"
                                auto-select-first
                                item-props
                                clearable 
                                :update:modelValue="previoussalesdata()"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Challan" v-model="bill.ps_chno" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Bill No" v-model="bill.ps_chbillno" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Bill Date" v-model="bill.ps_chdate" type='date' required></v-text-field>
                        </v-col>
                    </v-row>
                    <div class="position-sticky top-0 pa-3 mt-2">
                        <v-toolbar density="compact" :color="productcolor">
                            <v-toolbar-title>Products</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="addnewproduct" >
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </div>
                    <v-row v-for="(product, i) in bill.puritems" :key="i">
                        <v-col cols="12" sm="2">
                            <v-autocomplete
                                label="Product Name"
                                v-model="product.pi_productname"
                                :items="productnames"
                                item-title="productnames_productname"
                                item-value="productnames_productname"
                                density="default"
                                placeholder="Product Name"
                                auto-select-first
                                item-props
                                @blur="productselected(i)"
                               :autofocus="productautofocus"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-autocomplete
                                label="Batch No"
                                v-model="product.pi_batchno"
                                :items="batches.filter(function (el){return el.productname == product.pi_productname})"
                                item-title="batchno"
                                item-value="batchno"
                                density="default"
                                placeholder="Batch No"
                                auto-select-first
                                item-props
                                @blur="batchselected(i)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Exp" v-model="product.pi_expdate" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-text-field label="MRP" v-model="product.pi_mrp" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-text-field label="Rate" v-model="product.pi_rate" v-on:change="product.pi_rate = Number(product.pi_rate)" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-text-field label="Qty" v-model="product.pi_qty" v-on:change="product.pi_qty = Number(product.pi_qty)"  required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-text-field label="Free" v-model="product.pi_free" v-on:change="product.pi_free = Number(product.pi_free)" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-text-field label="Discount" v-model="product.pi_discount"  required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-icon
                                size="small"
                                @click="removeProduct(i)"
                                class="pt-10"
                                color="red"
                            >
                                mdi-delete
                            </v-icon>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Taxable" v-model="bill.ps_taxable"  required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="IGST" v-model="bill.ps_igst"  required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="CGST" v-model="bill.ps_cgst"  required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="SGST" v-model="bill.ps_sgst"  required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Billamount" v-model="bill.ps_billamount"  required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="auto">
                        <v-btn
                            depressed
                            color="primary"
                            type="submit"
                            @click=buttonClick()
                        >
                            Save
                        </v-btn>
                        </v-col>
                        <v-col cols="auto">
                        <v-btn
                            v-if="editedIndex != -1"
                            depressed
                            color="error"
                            type="submit"
                            @click=deleteData()
                        >
                            Delete
                        </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                <div v-if="showMessage">
                    <ShowError @closesnackbar="closesnackbar"/>
                </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script setup>
import { ref, provide, computed, onMounted,onBeforeMount,watch } from 'vue'
import { useAuthStore } from '@/stores/AuthStore'
import VendorService from '@/services/VendorService'
import PurchaseService from '@/services/PurchaseService'
import ShowError from '@/components/Showerror'
import ProductService from '@/services/ProductService'
import BatchService from '@/services/BatchService'
import PuritemService from '@/services/PuritemService'

const props = defineProps(['showGmwForm','editedItem','editedIndex', 'updateID'])
const emit = defineEmits(['closegmdialog'])

const authStore = useAuthStore()
var gmwswitch = ref(authStore.gmswitch)
var company = ref((gmwswitch.value) ? 'GMW' : 'SM')
var neworedit = ref((props.editedIndex == -1) ? 'New': 'Edit')
var formdialog = ref(props.showGmwForm)
var bill = ref(props.editedItem)
var vendors = ref([])
var gmvendors = ref([])
var gmwvendors = ref([])
var showMessage = ref(false)
var msgStatus = ref('primary')
var msg = ref('This is msg')
provide('msgStatus', msgStatus)
provide('msg', msg)
provide('showMessage', showMessage)
var productcolor = ref((authStore.gmswitch) ? 'deep-orange accent-4':'deep-purple accent-4')
var productautofocus = ref(false)
var partystate = ref('Wset Bengal')
var prevsales = ref([])

var productnames = ref([])
var batches = ref([])
var editeditemsales = []

async function addnewproduct(){
    if(typeof bill.value.ps_vname !== 'undefined'){
        bill.value.puritems.push({
            pi_productname:'',
            pi_batchno:'',
            pi_expdate:'',
            pi_mrp:'',
            pi_rate:'',
            pi_qty:'',
            pi_free:'',
            pi_discount:0,
            pi_igstrate:0,
            pi_cgstrate:0,
            pi_sgstrate:0,
            pi_total:0
        })
        productautofocus.value = true
    // var max_productsales = (bill.value.productsales.length -1)
    
    }else{
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = "Party is not selected" 
        
    }
    
}

async function removeProduct(i){
    bill.value.puritems.splice(i,1)
    //call the calculation program
}
async function create(){
    console.log(bill.value)
    try{
        if(gmwswitch.value){
            await PurchaseService.creategmw(bill.value)
        }else{
            await PurchaseService.createsm(bill.value)
        }
        formdialog.value = false
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
}
async function update(){
    console.log("ID is "+props.updateID)
    console.log(bill.value)
    try{
        if(gmwswitch.value){
            await PurchaseService.updategmw(bill.value,props.updateID)
        }else{
            await PurchaseService.updatesm(bill.value,props.updateID)
        }
        formdialog.value = false
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
}
async function buttonClick(){
    for (let i = 0; i < bill.value.puritems.length; i++){
        bill.value.puritems[i].pi_psid =  bill.value.ps_id,
        bill.value.puritems[i].pi_vname = bill.value.ps_vname,
        bill.value.puritems[i].pi_billno = bill.value.ps_chbillno,
        bill.value.puritems[i].pi_billdate = bill.value.ps_chdate,
        bill.value.puritems[i].pi_itemid = (await getitemid(bill.value.puritems[i].pi_productname, bill.value.puritems[i].pi_batchno)),
        bill.value.puritems[i].pi_total = (bill.value.puritems[i].pi_qty + bill.value.puritems[i].pi_free)
        if(props.editedIndex != -1 && !Object.keys(bill.value.puritems[i]).includes('id')){
            bill.value.puritems[i].id = ''
        }
    }
    if(props.editedIndex == -1){
        await create()
    }else{
        await update()
    }
}

async function getitemid(selectedproduct, selectedbatch){
    console.log("Getting item id "+selectedproduct+'-------'+selectedbatch)

    var items = batches.value.filter(function(el){
            return el.productname == selectedproduct &&
                    el.batchno == selectedbatch
            })

    console.log("Items are ")
    console.log(items)
    return items[0].itemid
}

function closesnackbar (){
    showMessage.value = false
}

async function getgmvendors(){
    try{
        var parties = (await VendorService.getall()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    gmvendors.value = parties
    return parties
}
async function getgmwvendors(){
    try{
        var parties = (await VendorService.getallgmw()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    gmwvendors.value = parties
    return parties
}

async function getproducts(){
    try{
        var product = gmwswitch.value ? (await ProductService.getallnamesgmw()).data : (await ProductService.getallnames()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    productnames.value = product
    return product
}

async function getbatches(){
    try{
        var batch = gmwswitch.value ? (await BatchService.getallgmw()).data : (await BatchService.getall()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    batches.value = batch
    return batch
}

async function gettotalvalue(){
    var taxable = 0
    var igst = 0
    var cgst = 0
    var sgst = 0
    
    for(let i = 0; i < bill.value.puritems.length; i++){
        var rate = Number(bill.value.puritems[i].pi_rate)
        var qty = Number(bill.value.puritems[i].pi_qty)
        var discountpercent = Number(bill.value.puritems[i].pi_discount)
        var igstpercent = Number(bill.value.puritems[i].pi_igstrate)
        var cgstpercent = Number(bill.value.puritems[i].pi_cgstrate)
        var sgstpercent = Number(bill.value.puritems[i].pi_sgstrate)
        var value = Math.round((rate * qty) * 100) / 100
        var discountvalue = Math.round((value * discountpercent /100) * 100) / 100
        var eachtaxable = Math.round((value - discountvalue) * 100) / 100
        var igstvalue = Math.round((eachtaxable * igstpercent / 100) * 100) / 100
        var cgstvalue = Math.round((eachtaxable * cgstpercent / 100) * 100) / 100
        var sgstvalue = Math.round((eachtaxable * sgstpercent / 100) * 100) / 100
        taxable = Math.round((taxable + eachtaxable) * 100) / 100
        igst = Math.round((igst + igstvalue) * 100) / 100
        cgst = Math.round((cgst + cgstvalue) * 100) / 100
        sgst = Math.round((sgst + sgstvalue) * 100) / 100
    }

    bill.value.ps_taxable = taxable
    bill.value.ps_igst = igst
    bill.value.ps_cgst = cgst
    bill.value.ps_sgst = sgst
    var billamount = Math.round(taxable + igst + cgst + sgst)
    bill.value.ps_billamount = billamount
}

async function productselected(i){
    var selectedproduct = bill.value.puritems[i].pi_productname
    if(selectedproduct != ''){
        var filteredproduct = productnames.value.filter(function(el){
            return el.productnames_productname == selectedproduct
        })[0]

        var filteredproductexist = (typeof filteredproduct !== 'undefined')

        if(filteredproductexist){
            bill.value.puritems[i].pi_hsncode = filteredproduct.hsn.hsn_code
            if(partystate.value != 'West Bengal'){
                bill.value.puritems[i].pi_igstrate = Number(filteredproduct.hsn.hsn_igstrate)
                bill.value.puritems[i].pi_cgstrate = 0
                bill.value.puritems[i].pi_sgstrate = 0
            }else{
                bill.value.puritems[i].pi_igstrate = 0
                bill.value.puritems[i].pi_cgstrate = Number(filteredproduct.hsn.hsn_cgstrate)
                bill.value.puritems[i].pi_sgstrate = Number(filteredproduct.hsn.hst_sgstrate)
            }
        }
        
    }
    
}

async function batchselected(i){
    console.log("Batch selected")
    console.log("previous sales ")
    console.log(prevsales.value)
    var selectedproduct = bill.value.puritems[i].pi_productname
    var selectedbatch = bill.value.puritems[i].pi_batchno
    
    if(selectedproduct != '' && selectedbatch != ''){
        console.log(selectedproduct +'----'+selectedbatch)
        var filteredbatch = batches.value.filter(function(el){
            return el.productname == selectedproduct &&
                    el.batchno == selectedbatch
            })[0]

        var filteredbatchexist = (typeof filteredbatch !== 'undefined')

        var filteredprevsales = prevsales.value.filter(function(el){
            return el.pi_productname == selectedproduct
        })[0]

        var prevsalesexist = (typeof filteredprevsales !== 'undefined')
        
        var itemalreadyexist = await existsinediteditem(selectedproduct,selectedbatch)
        if(!itemalreadyexist){   
            console.log('Item does not exists')               
            if(filteredbatchexist){
                bill.value.puritems[i].pi_expdate = filteredbatch.expdate
                bill.value.puritems[i].pi_mrp = filteredbatch.mrp
                var mrp = bill.value.puritems[i].pi_mrp
                var igstrate = bill.value.puritems[i].pi_igstrate
                var cgstrate = bill.value.puritems[i].pi_cgstrate
                var sgstrate = bill.value.puritems[i].pi_sgstrate

                var gstrate = (igstrate > 0 ) ? igstrate : (cgstrate + sgstrate)
                var rate = Math.round(((mrp - mrp*0.2)/((100 + gstrate)/100))*100)/100

                if(prevsalesexist){
                    console.log("previous sales exists")
                    bill.value.puritems[i].pi_rate = (filteredprevsales.pi_discount == 0) ? filteredprevsales.pi_rate : rate
                    bill.value.puritems[i].pi_discount = (filteredprevsales.pi_discount == 0) ? 0 : filteredprevsales.pi_discount
                    //Show snackbar if MRP changed
                    if((filteredprevsales.pi_mrp != filteredbatch.mrp) && filteredprevsales.pi_discount == 0){
                        showMessage.value = true
                        msgStatus.value = 'error'
                        msg.value = "MRP has changed"
                    }
                }else{
                    console.log("Previous sale does not exists")
                    bill.value.puritems[i].pi_rate = rate
                    //bill.value.productsales[i].discount = 0

                }

            }
        }
    }  
}
async function existsinediteditem(product, batch){
    var itemexist = false
    var filteredbatch = editeditemsales.filter(function(el){
            return el.productname == product &&
                    el.batchno == batch
            })
    if(filteredbatch.length > 0){
        itemexist = true
    }
    return itemexist
}
async function previoussalesdata(){
    var party = bill.value.ps_vname
    try{
        var product = gmwswitch.value ? (await PuritemService.getprevsalesgmw(party)).data : (await PuritemService.getprevsales(party)).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    prevsales.value = product
    return product
}

onBeforeMount(async () => {
    await getgmvendors()
    await getgmwvendors()
    await getproducts()
    await getbatches()
    vendors.value = (gmwswitch.value) ? gmwvendors.value : gmvendors.value

})

const qtycomputed = computed(() => {
  return bill.value.puritems.map(pd => pd.pi_qty)
})
const ratecomputed = computed(() => {
  return bill.value.puritems.map(pd => pd.pi_rate)
})
const discountcomputed = computed(() => {
  return bill.value.puritems.map(pd => pd.pi_discount)
})

const productcomputed = computed(() => {
  return bill.value.puritems.map(pd => pd.pi_productname)
})

watch(() => [qtycomputed, ratecomputed, discountcomputed], async(val)=>{
    await gettotalvalue()
    
},{ deep: true })

watch(() => [bill.value.ps_vname], async(val)=>{
    var party = vendors.value.filter(function (obj) {
            return obj.vname === bill.value.ps_vname;
        })[0]
    //var rate = ((newmrp - newmrp*0.2)/((100 + Number(gstrate))/100))
    //batch.value.rate = Math.round(rate*100)/100
    var partyexist = (typeof party !== 'undefined')

    console.log("Party Exists "+partyexist)
    console.log(party)
    
    if(partyexist){
        var gstlength = party.vgstno.length
        console.log("Length is "+gstlength)
        var strFirstTwo = party.vgstno.substring(0,2)
        console.log("First 2 string " +strFirstTwo)
        if((gstlength == 15) && strFirstTwo != 19){
            partystate.value = 'Other'
        }
        // selectedParty.value = party
        // bill.value.transport = party.transport
        // bill.value.console = party.con
        // bill.value.bills_state = party.parties_state

    }
    

})

</script>